var InFlight = InFlight || {};
InFlight.GTM = (function() {
  var GTM_EVENT = 'GTMEvent';

  var BUTTON_CLICKS = 'button-clicks';
  var LINK_CLICK = 'click-link';

  var EVENT_DETAILS = 'event-details';
  var LPA = 'LPA';
  var SUPPLIER = 'Supplier-Search';
  var SCPRS = 'SCPRS-Search';
  var HOMEPAGE = 'homepage';

  var CERT_STATE = {
    'NEW': 'New',
    'CONTINUE': 'Continue',
    'AMEND': 'Amend'
  };

  var _setUserId = function(data) {
    var currentUser = InFlight.User.currentUser();
    if (currentUser) {
      data.userId = InFlight.Utils.hash(currentUser);
    }
  };

  var _push = function(data) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(data);
    console.log('GTM', data);
  };

  var _bidderRegistrationComplete = function(userId) {
    var data = {
      event: GTM_EVENT,
      eventCategory: 'registration',
      eventAction: 'completion',
      eventLabel: ''
    };

    if (userId) {
      data.userId = InFlight.Utils.hash(userId);
    }

    _push(data);
  };

  var _login = function() {
    var data = {
      event: GTM_EVENT,
      eventCategory: 'login',
      eventAction: 'completion',
      eventLabel: ''
    };

    _setUserId(data);
    _push(data);
  };

  var _buttonClick = function(action, category, includeUser) {
    var data = {
      event: GTM_EVENT,
      eventCategory: category,
      eventAction: BUTTON_CLICKS,
      eventLabel: action
    };
  
    if (includeUser) {
      _setUserId(data);
    }
  
    _push(data);
  };

  var _linkClick = function(action, category, includeUser) {
    var data = {
      event: GTM_EVENT,
      eventCategory: category,
      eventAction: LINK_CLICK,
      eventLabel: action
    };

    if (includeUser) {
      _setUserId(data);
    }
    _push(data);
  };

  var _copyEventUrl = function() {
    _buttonClick('Copy Event URL', EVENT_DETAILS);
  };

  var _emailEvent = function() {
    _buttonClick('Email Event', EVENT_DETAILS);
  };

  var _basicSearch = function() {
    _buttonClick('Basic Search', EVENT_DETAILS);
  };

  var _advancedSearch = function() {
    _buttonClick('Advanced Search', EVENT_DETAILS);
  };

  var _searchLPA = function() {
    _buttonClick('Search', LPA);
  };

  var _advancedSearchLPA = function() {
    _buttonClick('Advanced Search', LPA);
  };

  var _searchSupplier = function() {
    _buttonClick('Search', SUPPLIER);
  };

  var _searchSCPRS = function() {
    _buttonClick('Search', SCPRS);
  };

  var _viewVendorAds = function() {
    _buttonClick('View Vendor Ads', EVENT_DETAILS);
  };

  var _viewEventPackage = function() {
    _buttonClick('View Event Package', EVENT_DETAILS);
  };

  var _homePageLinkClick = function(title) {
    _buttonClick(title, HOMEPAGE, true);
  }

  var _newUser = function() {
    _push({
      event: GTM_EVENT,
      eventCategory: BUTTON_CLICKS,
      eventAction: 'Next',
      eventLabel: 'Start a new registration form'
    });
  };

  var _returningUser = function() {
    _push({
      event: GTM_EVENT,
      eventCategory: BUTTON_CLICKS,
      eventAction: 'Next',
      eventLabel: 'Continue from where you left’'
    });
  };

  var _getVirtualPageView = function() {
    return {
      event: 'virtualPageview',
      virtualPageURL: location.pathname
    };
  };

  var _bidderRegistrationStep = function(title) {
    var data = _getVirtualPageView();
    data.virtualPageTitle = 'Bidder Registration - ' + title;
    data.bidderRegistrationStep = title;
    _push(data);
  };

  var _lookupBusStruct = function() {
    var data = _getVirtualPageView();
    data.virtualPageTitle = 'Bidder Registratiion - Find a Business Structure';
    data.bidderRegistrationStep = '';
    _push(data);
  };

  var _pageView = function() {
    var title = getPageTitle();
    var data = _getVirtualPageView();
    data.virtualPageTitle = title;
    _setUserId(data);
    _push(data);
  };

  var _homePageAppClick = function(appName) {
    _linkClick(appName, 'SupplierDashboard', true);
  };

  var listenForPageViews = function() {
    var lastPage;
    $(document).on('NLX:pageComplete', function() {
      var currentPage = location.pathname;
      if (currentPage !== lastPage) {
        _pageView();
      }
      lastPage = currentPage;
    });
  };
  listenForPageViews();

  var _triggerHJ = function(triggerName){
    if(!window['hj']){
      setTimeout(function(){
        _triggerHJ(triggerName);
      },100)
    }else{
      hj('trigger', triggerName);
    }
  };

  var _certificationState = undefined;
  var _certificationType = undefined;

  var _certification = {
    start: function(certTypes){
      var data = {
        event: GTM_EVENT,
        eventCategory: 'Cert',
        eventAction: 'Start Cert',
        eventLabel: certTypes
      };
      _setUserId(data);
      _push(data);
    },

    step: function(step, title) {
      var data = _getVirtualPageView();
      data.virtualPageTitle = 'Certification - ' + title;
      data.certificationStep = 'Step ' + step + ' - ' + title;
      data.certState = _certificationState;
      data.certType = _certificationType;
      _setUserId(data);
      _push(data);
    },

    help: function(eventAction, eventLabel){
      var data = {
        event: GTM_EVENT,
        eventCategory: 'Cert-Help',
        eventAction: eventAction,
        eventLabel: eventLabel
      };
  
      _setUserId(data);
      _push(data);
    },

    setState: function(state) {
      _certificationState = state;
    },

    setType: function(type) {
      _certificationType = type;
    },

    states: CERT_STATE,
  }

  return {
    pageView: _pageView,
    login: _login,
    home: {
      appClick: _homePageAppClick,
      linkClick: _homePageLinkClick,
    },
    events: {
      copyEventUrl: _copyEventUrl,
      emailEvent: _emailEvent,
      basicSearch: _basicSearch,
      advancedSearch: _advancedSearch,
      viewVendorAds: _viewVendorAds,
      viewEventPackage: _viewEventPackage,
    },
    lpa: {
      search: _searchLPA,
      advancedSearch: _advancedSearchLPA,
    },
    supplier: {
      search: _searchSupplier,
    },
    scprs: {
      search: _searchSCPRS,
    },
    bidderRegistration: {
      complete: _bidderRegistrationComplete,
      step: _bidderRegistrationStep,
      newUser: _newUser,
      returningUser: _returningUser,
      lookupBusStruct: _lookupBusStruct
    },
    certification: _certification
  };
})();
